module.exports = __webpack_public_path__ + "img/san-jose-room-3.bbf18ec6.jpg";